// extracted by css-extract-rspack-plugin
export default {"modal":"modal-tZR1Wv","suggestContainer":"suggestContainer-oUqjF3","suggestInput":"suggestInput-XKxfGI"};